// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://oijfukwsxdxbiqciqovb.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im9pamZ1a3dzeGR4YmlxY2lxb3ZiIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzU2Mjk4MjEsImV4cCI6MjA1MTIwNTgyMX0.W9JA0BRsU-Z9b5VEkDpeAYETcY2aNipMmp5KU5jbKm4";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);